import Action from '../../../decorators/Action';
import Computed from '../../../decorators/Computed';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export default class AbstractEntity extends AbstractSessionModel {
  public data;
  public type;

  constructor() {
    super();
  }

  public getSessionKey(): string {
    throw new Error('Method must be implemented in subclasses');
  }

  public getKeywords(): string[] {
    return this.data.keywords;
  }

  public getAllAddedKeywords(): string[] {
    return [...this.data.checkedKeywords, ...this.getCustomAddedKeywords()];
  }

  public getCheckedKeywords(): string[] {
    return this.data.checkedKeywords;
  }

  public isKeywordChecked(keyword: string): boolean {
    return this.data.checkedKeywords.includes(keyword);
  }

  public setKeywordChecked(keyword: string, selected: boolean): void {
    if (selected) {
      this.data.checkedKeywords.push(keyword);
    } else {
      const index = this.data.checkedKeywords.indexOf(keyword);
      if (index > -1) {
        this.data.checkedKeywords.splice(index, 1);
      }
    }
  }

  public getCustomAddedKeywords(): string[] {
    return this.data.customAddedKeywords || [];
  }

  public removeAllCustomAddedKeywords(): void {
    this.data.customAddedKeywords = [];
  }

  public setCustomAddedKeywords(keywords: string[]): void {
    this.data.customAddedKeywords = keywords;
  }

  @Computed()
  get areKeywordsProvided(): boolean {
    return this.data.areKeywordsProvided;
  }

  @Action()
  public setKeywordsProvided(value: boolean): void {
    this.data.areKeywordsProvided = value;
  }

  public toJSON() {
    return { type: this.type, data: this.data };
  }
}
